// removed by extract-text-webpack-plugin
module.exports = {"primaryColor":"#51A7E9","secondaryColor":"#79c5c5","backButtonColor":"#C5C5C5"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15110c75","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Dashboard/Views/Utils/SubComponents/ScheduleParts/DatePicker.vue
// module id = 0Ogy
// module chunks = 0